(function () {
  var selectors = {
    helper: '[data-bb-product-helper]',
    mainForm: 'main form[action*="/cart/add"]'
  };

  function emit(name, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, detail || {}));
    document.dispatchEvent(new CustomEvent('bb:conversion', { detail: Object.assign({ event: name }, detail || {}) }));
  }

  function mainForm() {
    var forms = Array.prototype.slice.call(document.querySelectorAll(selectors.mainForm));
    return forms.find(function (form) {
      return form.querySelector('button[name="add"],button[type="submit"],input[type="submit"]');
    }) || forms[0];
  }

  function setupTrust() {
    var price = document.querySelector('.product__info-container .product__block--price');
    if (!price || price.querySelector('.bb-conversion-trust')) return;
    var trust = document.createElement('div');
    trust.className = 'bb-conversion-trust';
    trust.setAttribute('aria-label', 'Sipariş güvenceleri');
    trust.innerHTML =
      '<div class="bb-conversion-trust__item"><span class="bb-conversion-trust__icon">✓</span><span><strong>Kişiye özel üretim</strong><br>Tasarımınız siparişe özel hazırlanır.</span></div>' +
      '<div class="bb-conversion-trust__item"><span class="bb-conversion-trust__icon">♡</span><span><strong>100+ mutlu müşteri</strong><br>Gerçek kutlamalardan güven veren deneyim.</span></div>' +
      '<div class="bb-conversion-trust__item"><span class="bb-conversion-trust__icon">◷</span><span><strong>Planlı teslimat</strong><br>İstanbul ve Kocaeli için tarih seçebilirsiniz.</span></div>' +
      '<div class="bb-conversion-trust__item"><span class="bb-conversion-trust__icon">◆</span><span><strong>Güvenli ödeme</strong><br>Ödemeniz Shopify altyapısıyla korunur.</span></div>';
    price.appendChild(trust);
  }

  function minDeliveryDate() {
    var date = new Date();
    date.setDate(date.getDate() + 2);
    return date.toISOString().slice(0, 10);
  }

  function setStep(root, step, focus) {
    step = Math.max(1, Math.min(3, Number(step) || 1));
    root.dataset.bbConversionCurrentStep = String(step);
    root.querySelectorAll('[data-bb-step-button]').forEach(function (button) {
      var buttonStep = Number(button.dataset.bbStepButton);
      button.classList.toggle('is-active', buttonStep === step);
      button.classList.toggle('is-complete', buttonStep < step);
      button.setAttribute('aria-current', buttonStep === step ? 'step' : 'false');
    });
    root.querySelectorAll('[data-bb-conversion-step]').forEach(function (element) {
      var hidden = Number(element.dataset.bbConversionStep) !== step;
      element.hidden = hidden;
      element.classList.toggle('bb-conversion-hidden', hidden);
    });
    if (focus) {
      var active = root.querySelector('[data-bb-step-button="' + step + '"]');
      if (active) active.focus({ preventScroll: true });
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function validateStep(root, step) {
    var fields = Array.prototype.slice.call(root.querySelectorAll('[data-bb-conversion-step="' + step + '"] input, [data-bb-conversion-step="' + step + '"] select, [data-bb-conversion-step="' + step + '"] textarea'));
    var invalid = fields.find(function (field) { return !field.disabled && !field.checkValidity(); });
    if (!invalid) return true;
    invalid.reportValidity();
    emit('form_error', { field_name: invalid.name || invalid.id || 'unknown', step: step });
    return false;
  }

  function setupFlow(root) {
    if (!root || root.dataset.bbConversionReady === 'true') return true;
    var card = root.querySelector('.bb-product-card');
    var fields = root.querySelector('.bb-fields');
    var variant = root.querySelector('.bb-variant-picker--inside');
    var cake = root.querySelector('#bb-cake');
    if (!card || !fields || !variant || !cake) return false;

    root.dataset.bbConversionReady = 'true';
    var nav = document.createElement('div');
    nav.className = 'bb-conversion-nav';
    nav.setAttribute('aria-label', 'Kişiselleştirme adımları');
    nav.innerHTML =
      '<button type="button" data-bb-step-button="1"><span>1</span>Pastanı seç</button>' +
      '<button type="button" data-bb-step-button="2"><span>2</span>Kişiselleştir</button>' +
      '<button type="button" data-bb-step-button="3"><span>3</span>Teslimat</button>';
    card.insertBefore(nav, variant);

    variant.dataset.bbConversionStep = '1';
    Array.prototype.slice.call(fields.children).forEach(function (field) {
      var input = field.querySelector('input,select,textarea');
      var isPersonal = input && (input.id === 'bb-message' || input.id === 'bb-note');
      field.dataset.bbConversionStep = isPersonal ? '2' : '1';
    });

    var delivery = document.createElement('div');
    delivery.className = 'bb-delivery-box';
    delivery.dataset.bbConversionStep = '3';
    delivery.innerHTML =
      '<h3>Teslimatı planlayın</h3>' +
      '<p>Tarih ve bölgeyi şimdi belirtin; uygunluk siparişinizden sonra ekibimiz tarafından teyit edilir.</p>' +
      '<div class="bb-delivery-box__grid">' +
        '<label>Teslimat bölgesi<select name="properties[Teslimat bölgesi]" data-bb-property required><option value="">Seçiniz</option><option>İstanbul Anadolu Yakası</option><option>İstanbul Avrupa Yakası</option><option>Kocaeli</option></select></label>' +
        '<label>Tercih edilen teslimat tarihi<input type="date" name="properties[Teslimat tarihi]" data-bb-property required></label>' +
      '</div>' +
      '<div class="bb-delivery-box__note"><span>ⓘ</span><span>Teslimat ücreti adres ve mesafeye göre değişir; ödeme adımında hesaplanır. Yalnızca İstanbul ve Kocaeli geneline teslimat yapılır.</span></div>';
    fields.appendChild(delivery);
    var dateInput = delivery.querySelector('input[type="date"]');
    dateInput.min = minDeliveryDate();

    ['.bb-order-summary', '.bb-assurance', '.bb-contact-row'].forEach(function (selector) {
      var element = root.querySelector(selector);
      if (element) element.dataset.bbConversionStep = '3';
    });

    [1, 2, 3].forEach(function (step) {
      var actions = document.createElement('div');
      actions.className = 'bb-conversion-actions';
      actions.dataset.bbConversionStep = String(step);
      if (step > 1) actions.innerHTML += '<button type="button" data-bb-prev-step="' + (step - 1) + '">Geri</button>';
      if (step < 3) actions.innerHTML += '<button type="button" data-bb-next-step="' + (step + 1) + '">Devam et</button>';
      card.appendChild(actions);
    });

    root.querySelectorAll('[data-bb-step-button]').forEach(function (button) {
      button.addEventListener('click', function () { setStep(root, button.dataset.bbStepButton, true); });
    });
    root.querySelectorAll('[data-bb-next-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var current = Number(root.dataset.bbConversionCurrentStep || 1);
        if (validateStep(root, current)) setStep(root, button.dataset.bbNextStep, true);
      });
    });
    root.querySelectorAll('[data-bb-prev-step]').forEach(function (button) {
      button.addEventListener('click', function () { setStep(root, button.dataset.bbPrevStep, true); });
    });

    var form = mainForm();
    if (form) {
      var formId = form.getAttribute('id');
      if (!formId) {
        formId = 'bb-main-product-form';
        form.setAttribute('id', formId);
      }
      root.querySelectorAll('[data-bb-property]').forEach(function (input) { input.setAttribute('form', formId); });
      form.addEventListener('invalid', function (event) {
        var field = event.target;
        var stepElement = field.closest('[data-bb-conversion-step]');
        if (stepElement) setStep(root, stepElement.dataset.bbConversionStep, false);
        emit('form_error', { field_name: field.name || field.id || 'unknown' });
      }, true);
    }

    var started = false;
    function markStarted() {
      if (!started) {
        started = true;
        emit('cake_customization_start', { product_id: document.querySelector('product-info')?.dataset.productId || '' });
      }
    }
    root.addEventListener('input', function (event) {
      markStarted();
      if (event.target.name === 'properties[Teslimat tarihi]') emit('delivery_date_selected', { delivery_date: event.target.value });
    });
    root.addEventListener('change', function (event) {
      markStarted();
      if (event.target.name === 'properties[Teslimat tarihi]') emit('delivery_date_selected', { delivery_date: event.target.value });
      var group = event.target.closest('.product-form__input');
      var label = group && group.querySelector('legend,.form__label,label');
      if (label && /kişi sayısı/i.test(label.textContent || '')) emit('serving_size_selected', { value: event.target.value });
    });
    root.querySelectorAll('a[href*="wa.me"]').forEach(function (link) {
      link.addEventListener('click', function () { emit('whatsapp_click', { source: 'product_customization' }); });
    });

    setStep(root, 1, false);
    return true;
  }

  // Visible price only: the price block also contains visually-hidden labels
  // ("Normal fiyat", "Satış ücreti", "Birim fiyat") that must not leak into the bar.
  function readProductPrice() {
    var price = document.querySelector('.product__block--price .f-price');
    if (!price) return '';
    var item = price.classList.contains('f-price--on-sale')
      ? price.querySelector('.f-price__sale .f-price-item--sale')
      : price.querySelector('.f-price__regular .f-price-item--regular');
    item = item || price.querySelector('.f-price-item, a') || price;
    return item.textContent.replace(/\s+/g, ' ').trim();
  }

  function setupSticky() {
    var bar = document.querySelector('.sticky-atc-bar');
    if (!bar || bar.dataset.bbConversionReady === 'true') return;
    bar.dataset.bbConversionReady = 'true';
    var inner = bar.querySelector('.sticky-atc-bar__inner');
    var form = bar.querySelector('.sticky-atc-bar__form');
    var productTitle = document.querySelector('.product__title')?.textContent.trim() || 'Pastanız';
    if (inner && form) {
      var summary = document.createElement('div');
      summary.className = 'sticky-atc-bar__mobile-summary md:hidden';
      summary.innerHTML = '<strong></strong><span></span>';
      summary.querySelector('strong').textContent = readProductPrice();
      summary.querySelector('span').textContent = productTitle;
      inner.insertBefore(summary, form);
      // Keep the mobile summary price in sync when the customer changes Kişi Sayısı/Lezzet.
      document.addEventListener('variant:changed', function () {
        window.setTimeout(function () {
          summary.querySelector('strong').textContent = readProductPrice();
        }, 0);
      });
    }
    var submit = bar.querySelector('button[name="add"] span');
    if (submit) submit.textContent = 'Özelleştir ve Sipariş Ver';
    bar.addEventListener('click', function (event) {
      var button = event.target.closest('button[name="add"]');
      if (!button || !window.matchMedia('(max-width: 767.98px)').matches) return;
      var helper = document.querySelector(selectors.helper);
      if (!helper) return;
      event.preventDefault();
      event.stopPropagation();
      var invalid = helper.querySelector('input:invalid,select:invalid,textarea:invalid');
      var invalidStep = invalid && invalid.closest('[data-bb-conversion-step]');
      setStep(helper, invalidStep ? invalidStep.dataset.bbConversionStep : 1, false);
      helper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, true);
  }

  function initialize() {
    setupTrust();
    setupSticky();
    var root = document.querySelector(selectors.helper);
    if (!root) return;
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (setupFlow(root) || attempts >= 40) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
